import { createBrowserRouter, Navigate } from 'react-router-dom'
import AigcEntry from '@/pages/index'

export const routerConfig = createBrowserRouter([
  {
    path: '/',
    element: <AigcEntry />
  },
  {
    path: '*',
    element: <Navigate to="/" replace />
  }
])
